var exports = {
  "D": "xdbfd91f1--481141--title",
};

module.exports = exports;
